export const contactSupportPageTranslations = {
  title: 'Contact Support',
  sections: {
    phone: {
      title: 'Phone',
      number: 'Number',
      phone_number: '09 70 80 85 95',
      opening_time: 'Opening time',
      opening_time_value:
        'Our services are open from 8:30am to 6:00pm Monday to Friday (no surcharges)',
    },
    appointment: {
      title: 'Appointment',
      axa_epargne_entreprise: 'AXA Employee Savings',
      standard_contract_link: 'Schedule an appointment about a standard contract under management',
      new_business: 'New Business',
      new_business_link:
        'Schedule an appointment about a the implementation of new business under standard contracts',
    },
    email: {
      title: 'Email',
      label: 'Contact form',
      button: 'Write to us',
      es_label: 'About Employee Savings contract',
      er_label: 'About Employee Retirement contract',
      inspector_label: 'Email from the collective inspector',
    },
    tour: {
      start_tour: 'Start the tour',
    },
  },
  contact_request: {
    title: 'Contact Form',
    label: 'Write to us',
    steps: {
      request: 'Request',
      confirmation: 'Confirmation',
    },
    sections: {
      request: 'Request',
      request_details: 'Request details',
    },
    fields: {
      subject: 'Subject',
      contract_id: 'Contract ID',
    },
    confirmation: {
      title: 'Email sent successfully',
      message: 'Your request was successfully sent via email.',
      confirmation: 'Got it',
    },
    choices: {
      subject: {
        navigation_help: 'Help navigating the client space',
        contribution_call: 'Contribution call',
        arbitration: 'Arbitration',
        amendment: 'Amendment',
        bia: 'BIA',
        monetized_leave: 'Monetized leave',
        death: 'Death',
        nominative_declaration: 'Nominative declaration',
        evaluation_request: 'Evaluation request',
        dsn: 'DSN',
        taxation: 'Taxation',
        merger: 'Merger',
        end_of_career_bonus: 'End-of-career bonus',
        liquidation: 'Liquidation',
        administrative_change: 'Administrative change',
        annuity_payment: 'Annuity payment',
        profit_sharing: 'Profit-sharing / Participation / PPV',
        matching_contribution: 'Matching contribution',
        regularization: 'Regularization',
        redemption: 'Redemption',
        contract_termination: 'Contract termination',
        account_statement: 'Account statement',
        pricing_commercial: 'Pricing / Commercial',
        transfer: 'Transfer',
        payment: 'Payment',
        other: 'Other (please specify)',
        complaint: 'Complaint',
      },
    },
  },
  accessibility: {
    back: 'Back',
  },
};
